import { useNode } from '@craftjs/core';
import { IDateIntervalCalc } from 'src/features/forms/base/controls/specials/DateIntervalCalc';
import { RPDF } from 'src/features/report/react-pdf';
import { useContextSelector } from 'use-context-selector';
import { RecordContext } from '../../RecordContext';
import { recordReportFormControlsResolver } from '../../recordReport.resolver';
import { renderNode } from '../../recordReport-helper';

export const DateIntervalCalcInput: IDateIntervalCalc = () => {
  const { id } = useNode();
  const nodes = useContextSelector(RecordContext, (v) => v.nodes);
  const linkedNodes = nodes.find((n) => n.id === id)?.linkedNodes;

  return (
    <RPDF.View>
      {linkedNodes &&
        Object.entries(linkedNodes).map(([, childId]) => renderNode(nodes, recordReportFormControlsResolver, childId))}
    </RPDF.View>
  );
};
